import React, { Fragment, useState, useEffect } from 'react';
import timeZoneList from '../../../../../data/timeZoneList';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { CardBody, Button, Card, CustomInput, Input, Label } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CompareArrowsOutlined from '@mui/icons-material/CompareArrowsOutlined';
import * as zChat from 'zendesk-chat-sdk';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_Ingetration_Channels } from '../../../../../constants/APIs';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const Weekdays = [
  { value: 'Monday', name: 'Monday' },
  { value: 'Tuesday', name: 'Tuesday' },
  { value: 'Wednesday', name: 'Wednesday' },
  { value: 'Thursday', name: 'Thursday' },
  { value: 'Friday', name: 'Friday' },
  { value: 'Saturday', name: 'Saturday' },
  { value: 'Sunday', name: 'Sunday' },
  { value: 'Weekends', name: 'Weekends' },
  { value: 'Weekdays', name: 'Weekdays' },
];
const timeList = [
  { value: '0', name: '0:00' },
  { value: '1', name: '1:00' },
  { value: 2, name: '2:00' },
  { value: '3', name: '3:00' },
  { value: '4', name: '4:00' },
  { value: '5', name: '5:00' },
  { value: '6', name: '6:00' },
  { value: '7', name: '7:00' },
  { value: '8', name: '8:00' },
  { value: '9', name: '9:00' },
  { value: '10', name: '10:00' },
  { value: '11', name: '11:00' },
  { value: '12', name: '12:00' },
  { value: '13', name: '13:00' },
  { value: '14', name: '14:00' },
  { value: '15', name: '15:00' },
  { value: '16', name: '16:00' },
  { value: '17', name: '17:00' },
  { value: '18', name: '18:00' },
  { value: '19', name: '19:00' },
  { value: '29', name: '20:00' },
  { value: '21', name: '21:00' },
  { value: '22', name: '22:00' },
  { value: '23', name: '23:00' },
];
const ChatBotLivChat = ({
  liveChatSettings,
  saveIntegration,
  country,
  allProperties,
  propertyData,
}) => {
  const [mewsList, setMewsList] = useState([]);
  const [amazonList, setAmazonList] = useState([]);
  const [timeZone, setTimeZone] = useState([]);
  const [liveChat, setLiveChat] = useState(
    liveChatSettings !== undefined && liveChatSettings !== null
      ? liveChatSettings
      : {
          properties: [],
          enabled: false,
          displayRule: '3',
          outSideIndicator: false,
          businessHours: {
            timeZone: propertyData.timeZone,
            time: [
              {
                id: 1,
                hourFrom: '0',
                hourTo: '1',
                day: '',
              },
            ],
          },
          provider: 0,
          enableOutOfOfficeMessage: false,
          outOfOfficeMessage: '',
          enableConnectingMessage: false,
          connectingMessage: '',
          zendesk: { accountKey: '', department: '', departmentId: '' },
          genesysPureCloudSettings: {
            openMessageIntegrationId: '',
            appUserName: '',
            appPassword: '',
          },
        }
  );
  const [liveChatSettingsList, setLiveChatSettingsList] = useState([]);
  const [maskData, setMaskData] = useState([]);
  const [zenDeskDepartments, setZenDeskDepartments] = useState([]);

  useEffect(() => {
    let val = [];
    timeZoneList.map((m, index) => m.TimeZones.map((t) => val.push(t)));
    val = val.sort((a, b) => a.localeCompare(b));
    setTimeZone(val);
    if (liveChatSettings !== undefined && liveChatSettings !== null) {
      let lst = [];
      let lstMask = [];
      liveChatSettings.map((m) => {
        let obj = {};
        let propertiesList = [];
        if (m?.properties !== undefined && m?.properties !== null) {
          m?.properties.map((p) => {
            [{ id: getGroupID(), name: 'Default' }, ...allProperties].map(
              (ap) => {
                if (ap.id === p) {
                  propertiesList.push({ label: ap.name, value: ap.id });
                }
              }
            );
          });
        }
        obj.outSideIndicator = m?.outSideIndicator || false;
        obj.displayRule = m?.displayRule || '3';
        obj.properties = propertiesList;
        obj.enabled = m?.enabled || false;
        obj.enableConnectingMessage = m?.enableConnectingMessage || false;
        obj.connectingMessage = m?.connectingMessage || '';
        obj.enableOutOfOfficeMessage = m?.enableOutOfOfficeMessage || false;
        obj.outOfOfficeMessage = m?.outOfOfficeMessage || '';
        if (m?.amazon !== undefined && m?.amazon !== null)
          obj.amazon = m?.amazon || { amazonId: '' };

        if (m?.mews !== undefined && m?.mews !== null)
          obj.mews = m?.mews || { mewsId: '' };

        obj.provider = m?.provider || 0;
        obj.businessHours = m?.businessHours || {
          timeZone: propertyData.timeZone,
          time: [{ id: 1, hourFrom: '0', hourTo: '1', day: '' }],
        };
        obj.zendesk = m?.zendesk || {
          accountKey: '',
          department: '',
          departmentId: '',
        };
        obj.genesysPureCloudSettings = m?.genesysPureCloudSettings || {
          openMessageIntegrationId: '',
          appUserName: '',
          appPassword: '',
        };
        lstMask.push({
          accountKey: mask(m?.zendesk?.accountKey) || '',
          department: m?.zendesk?.department || '',
          departmentId: m?.zendesk?.departmentId || '',
          clientToken: mask(m?.mews?.client) || '',
          accessToken: mask(m?.mews?.accessToken) || '',
          appUserName: mask(m?.genesysPureCloudSettings?.appUserName) || '',
          appPassword: mask(m?.genesysPureCloudSettings?.appPassword) || '',
        });
        lst.push(obj);
      });
      console.log('liveChatSettings lst', 143, lst);
      setLiveChatSettingsList(lst);
      setMaskData(lstMask);
    }
  }, [liveChatSettings]);

  console.log(maskData, 148, 'maskData');

  const handleAddLiveChatSettings = () => {
    let lst = [...liveChatSettingsList];
    lst.push({
      properties: [],
      enabled: false,
      displayRule: '3',
      outSideIndicator: false,
      businessHours: {
        timeZone: propertyData.timeZone,
        time: [
          {
            id: 1,
            hourFrom: '0',
            hourTo: '1',
            day: '',
          },
        ],
      },
      amazon: { amazonId: '' },
      provider: 0,
      mews: { mewsId: '' },
      enableOutOfOfficeMessage: false,
      outOfOfficeMessage: '',
      enableConnectingMessage: false,
      connectingMessage: '',
      zendesk: { accountKey: '', department: '', departmentId: '' },
      genesysPureCloudSettings: {
        openMessageIntegrationId: '',
        appUserName: '',
        appPassword: '',
      },
    });
    let masklist = [...maskData];
    masklist.push({
      accountKey: '',
      department: '',
      departmentId: '',
      clientToken: '',
      accessToken: '',
      gpAppUserName: '',
      gpAppPassword: '',
    });
    setMaskData(masklist);
    setLiveChatSettingsList(lst);
  };

  const handleRemoveLiveChatSettings = (index) => {
    let lst = [...liveChatSettingsList];
    lst = lst.filter((f, i) => i != index);
    setLiveChatSettingsList(lst);
  };

  useEffect(() => {
    // if (liveChat !== null && propertyData !== null) {
    //   let lst = liveChat.businessHours;
    //   if (lst.timeZone === '') {
    //     lst.timeZone = propertyData.timeZone;
    //     setLiveChat({ ...liveChat, businessHours: lst });
    //   }
    // }
    let body = {
      channels: ['Mews', 'Amazon'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      var integrations = res.data.filter((f) => f.disabled === false);
      if (integrations.length > 0) {
        const mews = integrations.filter((k) => k.channel === 'Mews');
        setMewsList(mews);
        const amazon = integrations.filter((k) => k.channel === 'Amazon');
        setAmazonList(amazon);
      }
    });
  }, [propertyData]);

  const mask = (value) => {
    let maskedValue = '';
    if (value !== undefined && value !== '' && value.length > 0) {
      for (let i = 0; i < value.length - 2; i++) {
        maskedValue += '*';
      }
      return maskedValue + value.substring(value.length - 2, value.length);
    }
    return maskedValue;
  };
  const handleBack = () => {
    setLiveChat(
      liveChatSettings !== undefined && liveChatSettings !== null
        ? liveChatSettings
        : {
            enabled: false,
            displayRule: '3',
            outSideIndicator: false,
            businessHours: {
              timeZone: propertyData.timeZone,
              time: [
                {
                  id: 1,
                  hourFrom: '0',
                  hourTo: '1',
                  day: '',
                },
              ],
            },
            amazon: { amazonId: '' },
            provider: 0,
            mews: { mewsId: '' },
            provider: 0,
            zendesk: { accountKey: '', department: '', departmentId: '' },
            genesysPureCloudSettings: {
              openMessageIntegrationId: '',
              appUserName: '',
              appPassword: '',
            },
          }
    );
  };
  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const RemoveBusinessHours = (id, index) => {
    let lstSettings = [...liveChatSettingsList];
    let lst = lstSettings[index].businessHours;
    lst.time = lst.time.filter((f) => f.id !== id);
    lstSettings[index].businessHours = lst;
    setLiveChatSettingsList(lstSettings);
  };
  const handleChange = (e) => {
    setLiveChat({ ...liveChat, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (
      liveChatSettings !== undefined &&
      liveChatSettings !== null &&
      liveChatSettings.zendesk !== null
    ) {
      // setMaskData({
      //   ...maskData,
      //   accountKey: mask(liveChatSettings.zendesk.accountKey),
      //   department: liveChatSettings.zendesk.department,
      //   departmentId: liveChatSettings.zendesk.departmentId,
      //   clientToken: mask(liveChatSettings?.mews?.clientToken),
      //   accessToken: mask(liveChatSettings?.mews?.accessToken),
      //   gpAppUserName: mask(
      //     liveChatSettings?.genesysPureCloudSettings?.appUserName
      //   ),
      //   gpAppPassword: mask(
      //     liveChatSettings?.genesysPureCloudSettings?.appPassword
      //   ),
      // });
      //handleConnectZendesk();
    }
  }, [liveChatSettings]);

  useEffect(() => {}, [setTimeZone]);
  // const handleSwitchChange = (value) => {
  //     setLiveChat({ ...liveChat, displayRule: value });
  //     handleOnOff(!value)
  // }
  const handleAccountKeyChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    lst[index].zendesk.accountKey = e.target.value;
    setLiveChatSettingsList(lst);
    let lstMask = [...maskData];
    lstMask[index].accountKey = mask(e.target.value);
    setMaskData(lstMask);
  };

  const handleMewsChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    var chat = lst[index];
    if (e.target.name === 'mewsId') chat.mews.mewsId = e.target.value;
    else if (e.target.name === 'enterpriseId')
      chat.mews.enterpriseId = e.target.value;
    else if (e.target.name === 'client') chat.mews.client = e.target.value;
    else if (e.target.name === 'accessToken')
      chat.mews.accessToken = e.target.value;
    lst[index] = chat;
    setLiveChatSettingsList(lst);
  };

  const handleAmazonChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    var chat = lst[index];
    if (e.target.name === 'amazonId') chat.amazon.amazonId = e.target.value;
    lst[index] = chat;
    setLiveChatSettingsList(lst);
  };

  const handleGenesysCloudIntegrationIdChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    var chat = lst[index];
    chat.genesysPureCloudSettings.openMessageIntegrationId = e.target.value;
    lst[index] = chat;
    setLiveChatSettingsList(lst);
  };

  const handleGenesysCloudUserNameChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    var chat = lst[index];
    chat.genesysPureCloudSettings.appUserName = e.target.value;
    lst[index] = chat;
    setLiveChatSettingsList(lst);
    let lstMask = [...maskData];
    lstMask[index].appUserName = mask(e.target.value);
    setMaskData(lstMask);
  };

  const handleGenesysCloudPasswordChange = (e, index) => {
    e.persist();
    let lst = [...liveChatSettingsList];
    var chat = lst[index];
    chat.genesysPureCloudSettings.appPassword = e.target.value;
    lst[index] = chat;
    setLiveChatSettingsList(lst);
    let lstMask = [...maskData];
    lstMask[index].appPassword = mask(e.target.value);
    setMaskData(lstMask);
  };

  const handleTimeZone = (event, index) => {
    console.log(323, event, index);
    event.persist();
    let lst = [...liveChatSettingsList];
    let businessHours = lst[index].businessHours;
    businessHours.timeZone = event.target.value;
    lst[index].businessHours = businessHours;
    console.log(lst);
    setLiveChatSettingsList(lst);
  };

  const handleSave = () => {
    let lst = [...liveChatSettingsList];
    lst.map((m, i) => {
      m.properties = m.properties.map((p) => p.value);
    });
    saveIntegration({ liveChatSettings: liveChatSettingsList });
  };

  const handleConnectZendesk = (index) => {
    let lst = [...liveChatSettingsList];
    var connection_status = zChat.getConnectionStatus();
    if (connection_status == 'closed') {
      zChat.init({
        account_key: lst[index].zendesk.accountKey,
      });
      zChat.on('connection_update', function (status) {
        if (status === 'connected') {
          var departments = zChat.getAllDepartments();
          console.log(departments);
          lst[index].departments = departments;
        } else if (status === 'closed') {
        }
      });
    } else if (connection_status == 'connected') {
      var departments = zChat.getAllDepartments();
      lst[index].departments = departments;
      setLiveChatSettingsList(lst);
    }
  };

  const handleChangeSelect = (e, index) => {
    console.log(e);
    let lst = [...liveChatSettingsList];
    let zen = lst[index];
    zen.zendesk.department = e.label;
    zen.zendesk.departmentId = e.value;
    lst[index] = zen;
    setLiveChatSettingsList(lst);
    let lstMask = [...maskData];
    lstMask[index].department = e.label;
    lstMask[index].departmentId = mask(e.value);
    setMaskData(lstMask);
  };
  const handleBusinessHours = (type, value, id, index) => {
    console.log(type, value, id, index);
    let lst = [...liveChatSettingsList];
    let businessHours = lst[index].businessHours;
    let time = businessHours.time.filter((f) => f.id === id);
    if (businessHours.time.filter((f) => f.id === id).length > 0) {
      switch (type) {
        case 'hourFrom':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourFrom = value;
            return f;
          });
          break;

        case 'hourTo':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourTo = value;
            return f;
          });
          break;

        case 'day':
          businessHours.time.map((f) => {
            if (f.id === id) f.day = value;
            return f;
          });
          break;
      }
    }
    lst[index].businessHours = businessHours;
    setLiveChatSettingsList(lst);
  };

  const AddBusinessHours = (index) => {
    let lstSettings = [...liveChatSettingsList];
    let lst = lstSettings[index].businessHours;
    lst.time.push({
      id: createUUID(),
      hourFrom: '0',
      hourTo: '1',
      day: Weekdays.filter((f) => lst.time.filter((l) => l.day === f.value))[0],
    });
    lstSettings[index].businessHours = lst;
    setLiveChatSettingsList(lstSettings);
  };

  const handleChangeSettings = (e, index) => {
    let lstSettings = [...liveChatSettingsList];
    lstSettings[index][e.target.name] = e.target.value;
    setLiveChatSettingsList(lstSettings);
  };

  const handleSettingsProperties = (e, index) => {
    let lst = [...liveChatSettingsList];
    lst[index].properties = e;
    setLiveChatSettingsList(lst);
  };

  const handleSettingsChanges = (e, value, index) => {
    let lst = [...liveChatSettingsList];
    lst[index][e] = value;
    setLiveChatSettingsList(lst);
  };

  const handleRemoveSettings = (i) => {
    let lst = [...liveChatSettingsList];
    setLiveChatSettingsList(lst.filter((f, index) => i !== index));
  };

  const handleRecentProperties = (lst) => {
    let lstProperties = [...liveChatSettingsList].map((m) => m.properties);
    return lst.filter(
      (f) =>
        lstProperties
          .map((m) => m.map((i) => i.value))
          .flat()
          .filter((p) => p === f.id).length === 0
    );
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody className="mb-2">
          <div className="text-center">
            <h6>Live Chat </h6>
          </div>
          <Separator className="mb-3" />
          {liveChatSettingsList !== null &&
            liveChatSettingsList.length > 0 &&
            liveChatSettingsList.map((m, i) => (
              <Fragment>
                <div className="row mt-2 mb-3">
                  <Colxx md="12">
                    <Select
                      isMulti={true}
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="form-field-name"
                      options={handleRecentProperties([...allProperties]).map(
                        (x, i) => {
                          return { label: x.name, value: x.id, key: x.id };
                        }
                      )}
                      value={m?.properties}
                      onChange={(val) => handleSettingsProperties(val, i)}
                    />
                  </Colxx>
                </div>
                <div className="text-left mb-4 ">
                  <h5 style={{ marginTop: '0.15rem' }}>Availability</h5>
                </div>
                <div className="row mt-2 ml-2 mb-1">
                  <div className="d-flex w-100">
                    <h6>Enable Live Chat</h6>
                    <Switch
                      className="agentswitch custom-switch-primary 
                                    custom-switch-small ml-2"
                      checked={m?.enabled}
                      name="enabled"
                      onChange={(e) => {
                        handleSettingsChanges('enabled', e, i);
                      }}
                    />
                  </div>
                  <div className="row " style={{ marginLeft: '0.5rem' }}>
                    When enabled, the live chat option will be presented on your
                    website digital assistant widget
                  </div>
                </div>

                <div className="row mt-2 ml-2">
                  <h6>Display rules</h6>
                </div>
                <div className="row " style={{ marginLeft: '0.75rem' }}>
                  Select when you want to present the live chat option to your
                  customers
                </div>
                <div className="ml-2">
                  <div className="row mt-1 ml-2">
                    <div className="mt-1 ml-1">
                      <CustomInput
                        type="radio"
                        name="displayRule"
                        checked={m?.displayRule === 0 ? true : false}
                        onChange={(event) =>
                          handleSettingsChanges('displayRule', 0, i)
                        }
                      >
                        Always visible
                      </CustomInput>
                    </div>
                  </div>
                  <div className="row mt-1 mb-2 ml-2">
                    <div className=" d-flex mt-1 ml-1">
                      <CustomInput
                        type="radio"
                        name="displayRule1"
                        checked={m?.displayRule === 2 ? true : false}
                        onChange={(event) =>
                          handleSettingsChanges('displayRule', 2, i)
                        }
                      >
                        Set your business hours
                      </CustomInput>
                    </div>
                    {m?.displayRule === 2 && (
                      <Fragment>
                        <div className="row mt-2">
                          <Colxx xxs="12" md="6" className="mb-2 ">
                            <Label>Time Zone </Label>
                            <Input
                              type="select"
                              className="text-small dropdown-menu dropdowntimezone"
                              name="type"
                              value={m?.businessHours?.timeZone}
                              onChange={(e) => handleTimeZone(e, i)}
                            >
                              {timeZone !== undefined &&
                                timeZone.length > 0 &&
                                timeZone.map((t) => (
                                  <option
                                    className="dropdown-item"
                                    key={t}
                                    value={t}
                                  >
                                    {t}
                                  </option>
                                ))}
                            </Input>
                          </Colxx>
                          <div className="ml-3">
                            Please note: This timezone setting only impacts
                            Conversations live chat.
                          </div>
                        </div>
                        {console.log(561, m?.businessHours)}
                        {m?.businessHours?.time &&
                          m?.businessHours?.time.length > 0 &&
                          m?.businessHours?.time.map((b, index) => (
                            <div
                              key={b.id}
                              className="d-flex  col-md-12  mt-2"
                              style={{ marginLeft: '-10px' }}
                            >
                              <Input
                                type="select"
                                value={b?.day}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'day',
                                    e.target.value,
                                    b.id,
                                    i
                                  )
                                }
                              >
                                <option value="0">Please Select</option>
                                {Weekdays.length > 0 &&
                                  Weekdays.map((w, index) => {
                                    // if (
                                    //   m?.businessHours.time.filter(
                                    //     (f) => f.day === w.value && f.id !== m.id
                                    //   ).length == 0
                                    // )
                                    return (
                                      <option key={w.value} value={w.value}>
                                        {w.name}
                                      </option>
                                    );
                                  })}
                              </Input>
                              <Input
                                type="select"
                                className="ml-2"
                                value={b?.hourFrom}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'hourFrom',
                                    e.target.value,
                                    b.id,
                                    i
                                  )
                                }
                              >
                                {timeList.length > 0 &&
                                  timeList.map((m, index) => (
                                    <option key={m.value} value={m.value}>
                                      {m.name}
                                    </option>
                                  ))}
                              </Input>
                              <span className="ml-2 mt-2 ">to</span>
                              <Input
                                type="select"
                                className="ml-2"
                                value={b?.hourTo}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'hourTo',
                                    e.target.value,
                                    b.id,
                                    i
                                  )
                                }
                              >
                                {timeList.length > 0 &&
                                  timeList.map((m, index) => (
                                    <option key={m.value} value={m.value}>
                                      {m.name}
                                    </option>
                                  ))}
                              </Input>
                              <Button
                                color="danger"
                                size="xs"
                                className="ml-2"
                                outline
                                onClick={() => {
                                  RemoveBusinessHours(b.id, i);
                                }}
                              >
                                -
                              </Button>
                            </div>
                          ))}
                        <div className="row col-md-12 mt-3 ml-0">
                          <Button
                            color="primary"
                            outline
                            size="sm"
                            onClick={() => AddBusinessHours(i)}
                          >
                            Add hours
                          </Button>
                        </div>
                        <div className="row mt-2 d-none">
                          <CustomInput
                            type="checkbox"
                            checked={m?.outSideIndicator}
                            onChange={(event) => {
                              handleChangeSettings(event, i);
                            }}
                          >
                            Display the live chat widget with an offline
                            indicator outside of business hours
                          </CustomInput>
                        </div>
                      </Fragment>
                    )}
                  </div>
                  <div className="mt-1 mb-2 ml-1">
                    <div className="d-flex mt-1">
                      <h6 style={{ marginTop: '0.15rem' }}>
                        Enable Connecting Message
                      </h6>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={m?.enableConnectingMessage}
                        name="enabled"
                        onChange={(e) =>
                          handleSettingsChanges('enableConnectingMessage', e, i)
                        }
                      />
                    </div>
                    <div className="mb-2 mt-1">
                      <Label>
                        When someone requests a live chat, this message is sent
                        automatically.
                      </Label>
                      <Input
                        type="textarea"
                        name="connectingMessage"
                        onChange={(e) => {
                          handleChangeSettings(e, i);
                        }}
                        placeholder="Thanks for your message — we’ll get back to you shortly"
                        value={m?.connectingMessage}
                        style={{
                          width: '100%',
                          minHeight: '60px',
                          resize: 'both',
                          overflow: 'auto',
                        }}
                      />
                    </div>
                  </div>

                  <div className=" mt-1 mb-2 ml-1">
                    <div className="d-flex mt-1">
                      <h6 style={{ marginTop: '0.15rem' }}>
                        Enable Out of Office Message
                      </h6>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={m?.enableOutOfOfficeMessage}
                        name="enabled"
                        onChange={(e) =>
                          handleSettingsChanges(
                            'enableOutOfOfficeMessage',
                            e,
                            i
                          )
                        }
                      />
                    </div>
                    <div className="mb-2 mt-1">
                      <Label>
                        If a chat is transferred to a live agent after hours,
                        this message is sent automatically.
                      </Label>
                      <Input
                        type="textarea"
                        name="outOfOfficeMessage"
                        onChange={(e) => {
                          handleChangeSettings(e, i);
                        }}
                        placeholder="You've reached us outside our business hours (Mon-Fri, 8 am-6 pm). We'll get back to you soon."
                        value={m?.outOfOfficeMessage}
                        style={{
                          width: '100%',
                          minHeight: '60px',
                          resize: 'both',
                          overflow: 'auto',
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-2 ml-2">
                  <h6>Choose Your Provider</h6>
                </div>
                <div className="ml-2">
                  <div className="row mt-1 ml-0">
                    <Colxx xxs="12" md="12" className="mb-2">
                      <div className="d-flex">
                        <CustomInput
                          type="radio"
                          name="provider"
                          checked={m?.provider === 0 ? true : false}
                          onChange={(event) =>
                            handleSettingsChanges('provider', 0, i)
                          }
                        >
                          Myma.ai
                        </CustomInput>
                        <CustomInput
                          className="ml-2"
                          type="radio"
                          name="provider1"
                          checked={m?.provider === 1 ? true : false}
                          onChange={(event) =>
                            handleSettingsChanges('provider', 1, i)
                          }
                        >
                          Zendesk
                        </CustomInput>
                        <CustomInput
                          className="ml-2"
                          type="radio"
                          name="provider1"
                          checked={m?.provider === 2 ? true : false}
                          onChange={(event) =>
                            handleSettingsChanges('provider', 2, i)
                          }
                        >
                          Genesys PureCloud
                        </CustomInput>
                        <CustomInput
                          className="ml-2"
                          type="radio"
                          name="provider3"
                          checked={m?.provider === 3 ? true : false}
                          onChange={(event) =>
                            handleSettingsChanges('provider', 3, i)
                          }
                        >
                          Mews
                        </CustomInput>
                        <CustomInput
                          className="ml-2"
                          type="radio"
                          name="provider4"
                          checked={m?.provider === 4 ? true : false}
                          onChange={(event) =>
                            handleSettingsChanges('provider', 4, i)
                          }
                        >
                          Amazon
                        </CustomInput>
                      </div>
                    </Colxx>
                    {m?.provider === 3 && (
                      <Fragment>
                        <Colxx xxs="12" md="6" className="mb-2 mt-1">
                          <Input
                            type="select"
                            name="mewsId"
                            onChange={(e) => handleMewsChange(e, i)}
                            placeholder="Please Select"
                            value={m?.mews?.mewsId}
                          >
                            <option value="">Please Select</option>
                            {mewsList.length > 0 &&
                              mewsList.map((m) => (
                                <option value={m.id}>{m.name}</option>
                              ))}
                          </Input>
                        </Colxx>
                      </Fragment>
                    )}
                    {m?.provider === 1 && (
                      <Fragment>
                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          <Label>Account Key</Label>
                          <Input
                            type="text"
                            name="accountKey"
                            onChange={(e) => handleAccountKeyChange(e, i)}
                            placeholder="Account key"
                            defaultValue={maskData[i]?.accountKey}
                          />
                        </Colxx>
                        {m?.zendesk.department !== '' &&
                          m?.zendesk?.departments &&
                          m?.zendesk?.departments.length === 0 && (
                            <Colxx xxs="12" md="8" className="mb-2 mt-1">
                              <Label>Default Department</Label>
                              <Input
                                type="text"
                                name="department"
                                defaultValue={m?.zendesk.department}
                                disabled="disabled"
                              />
                            </Colxx>
                          )}
                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          {m?.zendesk?.departments &&
                            m?.zendesk?.departments.length > 0 && (
                              <Fragment>
                                <Label>Default Department</Label>
                                <Select
                                  isMulti={false}
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  name="departmentId"
                                  placeholder="Select Department"
                                  onChange={(e) => handleChangeSelect(e, i)}
                                  defaultValue={m?.zendesk.departmentId}
                                  options={
                                    m?.zendesk?.departments
                                      ? reactSelectOptionDiffrentPro(
                                          m?.zendesk?.departments,
                                          true,
                                          'id',
                                          'name',
                                          ''
                                        )
                                      : []
                                  }
                                />
                              </Fragment>
                            )}
                        </Colxx>
                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          {m?.zendesk?.departments &&
                            m?.zendesk?.departments.length === 0 &&
                            m?.zendesk.accountKey !== '' && (
                              <Button
                                onClick={() => handleConnectZendesk(i)}
                                color="secondary"
                                outline
                                size="xs"
                                style={{ borderRadius: '6px' }}
                              >
                                Connect to Zendesk to Set the Default Department
                              </Button>
                            )}
                        </Colxx>
                      </Fragment>
                    )}
                    {m?.provider === 2 && (
                      <Fragment>
                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          <Label>Open Message Integration Id</Label>
                          <Input
                            type="text"
                            name="openMessageIntegrationId"
                            onChange={(e) =>
                              handleGenesysCloudIntegrationIdChange(e, i)
                            }
                            placeholder=""
                            defaultValue={
                              m?.genesysPureCloudSettings
                                .openMessageIntegrationId
                            }
                          />
                        </Colxx>

                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          <Label>Username</Label>
                          <Input
                            type="text"
                            name="appUserName"
                            onChange={(e) =>
                              handleGenesysCloudUserNameChange(e, i)
                            }
                            placeholder=""
                            defaultValue={maskData[i]?.appUserName}
                          />
                        </Colxx>
                        <Colxx xxs="12" md="8" className="mb-2 mt-1">
                          <Label>Password</Label>
                          <Input
                            type="text"
                            name="appPassword"
                            onChange={(e) =>
                              handleGenesysCloudPasswordChange(e, i)
                            }
                            placeholder=""
                            defaultValue={maskData[i]?.appPassword}
                          />
                        </Colxx>
                      </Fragment>
                    )}
                    {m?.provider === 4 && (
                      <Fragment>
                        <Colxx xxs="12" md="6" className="mb-2 mt-1">
                          <Input
                            type="select"
                            name="amazonId"
                            onChange={(e) => handleAmazonChange(e, i)}
                            placeholder="Please Select"
                            value={m?.amazon?.amazonId}
                          >
                            <option value="">Please Select</option>
                            {amazonList.length > 0 &&
                              amazonList.map((m) => (
                                <option value={m.id}>{m.name}</option>
                              ))}
                          </Input>
                        </Colxx>
                      </Fragment>
                    )}
                  </div>
                </div>
                <div className="text-right mt-4 mb-3">
                  <Button
                    outline
                    onClick={() => handleRemoveSettings(i)}
                    size="xs"
                    color="secondary"
                  >
                    Remove Property Settings
                  </Button>
                </div>
              </Fragment>
            ))}
          {handleRecentProperties(allProperties).length > 0 && (
            <Fragment>
              <Separator className="my-3" />
              <Colxx xxs="12" className="my-3">
                <Button
                  color="primary"
                  outline
                  size="xs"
                  onClick={handleAddLiveChatSettings}
                >
                  + Add Property Settings
                </Button>
              </Colxx>
            </Fragment>
          )}
          <Separator className="my-3" />
          <div className="text-center mt-4 mb-3">
            <Button onClick={handleSave} size="xs" color="primary">
              Save
            </Button>

            <Button
              color="secondary"
              size="xs"
              onClick={handleBack}
              className="ml-2"
            >
              Reset
            </Button>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { country } = settings;
  return {
    country,
  };
};

export default injectIntl(connect(mapStateToProps, {})(ChatBotLivChat));
